import { FC } from 'react';
import cn from 'classnames';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { SortByDropdown, SortByDropdownProps } from '@app/components';

import './SortByDropdownWithIcon.scss';

const cnBem = createBemBlockBuilder(['sortByWithIcon']);
const cnBemSearchResults = createBemBlockBuilder(['searchResultsPage']);

// TODO: Remove this component and replace it with SortByDropdown
export const SortByDropdownWithIcon: FC<SortByDropdownProps> = ({
  options,
  sortField,
  sortDirection,
  onSelect,
}) => {
  return (
    <div className={cnBem()}>
      <SortByDropdown
        options={options}
        styleType="standard"
        sortField={sortField}
        sortDirection={sortDirection}
        hideLabel
        className={cn('compactDropdown', cnBemSearchResults('__dropdownItem'))}
        onSelect={onSelect}
      />
    </div>
  );
};
